import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Table, Loader } from 'semantic-ui-react';

import './styles.css';

class SnukTableLoadMore extends Component {
  constructor(props) {
    super(props);
    this.loadMore = this.loadMore.bind(this);
  }

  loadMore() {
    const { loadMoreAction, loadMoreActionArgs, isLoadingMore } = this.props;
    if (!isLoadingMore) loadMoreAction(...loadMoreActionArgs);
  }

  render() {
    const { t, colSpan, isLoadingMore } = this.props;
    return (
      <Table.Row>
        <Table.Cell onClick={this.loadMore} colSpan={colSpan} textAlign="center" className="load-more">
          {isLoadingMore
            ? <Loader size="small" active inline="centered" />
            : <span>{t('common.loadmore')}</span>
          }
        </Table.Cell>
      </Table.Row>
    );
  }
}

SnukTableLoadMore.propTypes = {
  t: PropTypes.func.isRequired,
  loadMoreAction: PropTypes.func.isRequired,
  loadMoreActionArgs: PropTypes.arrayOf(PropTypes.any),
  colSpan: PropTypes.string.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
};

SnukTableLoadMore.defaultProps = {
  loadMoreActionArgs: [],
};

export default translate()(SnukTableLoadMore);



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableLoadMore.js